"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSession = instanceOfSession;
exports.SessionFromJSON = SessionFromJSON;
exports.SessionFromJSONTyped = SessionFromJSONTyped;
exports.SessionToJSON = SessionToJSON;
/**
 * Check if a given object implements the Session interface.
 */
function instanceOfSession(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
function SessionFromJSON(json) {
    return SessionFromJSONTyped(json, false);
}
function SessionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
    };
}
function SessionToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
    };
}
